import type { AbstractMesh } from '@babylonjs/core';

// Warming - this function modifies the allMeshes argument.
// Why? Because we want to collect all parent meshes in a single pass instead of O(n²) iteration.
const getParentMeshes = (
  mesh: AbstractMesh,
  allMeshes: Record<string, AbstractMesh>,
): void => {
  let currentMesh = mesh;

  while (currentMesh.parent) {
    const parentMesh = currentMesh.parent as AbstractMesh;
    allMeshes[parentMesh.id] ??= parentMesh;

    currentMesh = parentMesh;
  }
};

export default getParentMeshes;
